import { FacilitySortOption } from '@rematter/frontend-lib-api-client';
import { FacilityRecord } from '@rematter/modules/facilities/types/facility';

import { createQueryHook } from '~/shared/providers/api';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const useFacilitiesQueryForFacilityGroupForm = createQueryHook(
  'facilities.facilitiesForFacilityGroupForm',
  (params: {
    searchTerm?: string;
    sorting?: FacilitySortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    facilities: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        __typename: true,
        id: true,
        facilityName: true,
        facilityType: true,
        timezone: true,
        address: {
          streetAddress: true,
          city: true,
          state: true,
          country: true,
          postalCode: true,
        },
        customAttributes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { facilities: FacilityRecord[]; total?: number } => ({
      facilities:
        data?.facilities.entries.map((facility) => ({
          id: facility.id,
          facilityName: facility.facilityName,
          facilityType: facility.facilityType,
          timezone: facility.timezone,
          address: facility.address
            ? {
                streetAddress: facility.address.streetAddress,
                city: facility.address.city,
                state: facility.address.state,
                country: facility.address.country,
                postalCode: facility.address.postalCode,
              }
            : undefined,
          timestamps: {
            createdAt: parseZonedDateTime(facility.timestamps.createdAt),
            updatedAt: parseZonedDateTime(facility.timestamps.updatedAt),
          },
        })) ?? [],
      total: data?.facilities.page.total ?? undefined,
    }),
  },
);
